import { Layout } from "antd";
import { ReactComponent as ArrowRight } from "assets/icons/arrow-right-with-line.svg";
import { handleAdditionalHeader } from "layouts/services/data.transformers";
import { useTranslation } from "react-i18next";

const { Header } = Layout;


const PageHeader = ({ page, title, goBack, prx, dscode, onClickHeader, handleQuestionBtn }) => {
  const { t } = useTranslation();

  return (
    <Header className=" fixed h-auto px-5 w-full max-w-2xl mx-auto py-3 bg-gray--12 sm:bg-white  sm:mt-5 sm:shadow-sm sm:rounded-lg  z-40">
      <div className=" flex justify-between items-center ">
        <div className="cursor-pointer">
          <ArrowRight onClick={() => goBack()} />
        </div>
        <div className="body-14px-regular ">
          <span className="text-gray-0 ">{title}</span>
        </div>
        <div className="page-header-additional caption-12px-medium">
          {handleAdditionalHeader(page, prx, dscode, t, onClickHeader, handleQuestionBtn)}
        </div >
      </div >
    </Header >
  );
};

export default PageHeader;